<script>
import baseInput from './baseInput'
import { Chrome } from 'vue-color'

var colors = '#194d33'

export default {

    mixins: [ baseInput ],

    components: {
        'chrome-picker': Chrome,
    },

    name: 'color-picker',

    props: {
        value: null,
        id: String,
        disabled: Boolean,
        readonly: Boolean,
        placeholder: String,
        noRadius: Boolean,
    },

    data () {
        return {
            colors,
            isOpen: false,
            hasFocus: false,
        }
    },

    watch: {
        colors(value){
            if (value.hex) {
                this.internalValue = value.hex
            }
        }
    },

    methods: {
        enter()
        {
            this.$emit('enter')
        },
        focus()
        {
            this.hasFocus = true
            this.isOpen = false
        },
        blur()
        {
            this.hasFocus = false
        },
    },

    mounted(){
        this.interlValue = this.colors
    },

}
</script>

<template lang="html">

    <div class="">
        <div class="engage-simple-input colorpicker" :class="{'no-radius': noRadius }">
            <div class="form-group mb-1" >
                <div class="input-group">
                    <div class="input-group-addon text-center simpleInput" :class="{ 'focus' : hasFocus }">
                        <span v-if="!internalValue" class="cp border" @click="isOpen=!isOpen" ref="colorInput" :style="'background-color:' + colors.hex"></span>
                        <span v-if="internalValue" class="cp border" @click="isOpen=!isOpen" ref="colorInput" :style="'background-color:' + internalValue"></span>

                    </div>

                    <input
                    type="text"
                    v-model="internalValue"
                    :disabled="disabled"
                    style="width:68px"
                    maxlength="7"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    @keypress.enter="enter"
                    :id="id"
                    class="simple iconed"
                    @focus="focus"
                    @blur="blur"
                    :required="required"
                    >

                </div>
            </div>
        </div>
        <transition tag="div" name="page">
            <chrome-picker ref="colorPicker" v-show="isOpen" v-model="colors" />
        </transition>
    </div>

</template>



// WEBPACK FOOTER //
// src/components/forms/elements/colorPicker.vue